import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { usePagination } from '../../contexts/PaginationContext';
import { useNotification } from '../../contexts/NotificationContext';
import PaginationControls from '../../components/PaginationControls';
import SalasTable from '../../components/SalasTable';
import Footer from '../../components/Footer';
import { authFetch } from '../../utils/authFetch';
import 'bootstrap-icons/font/bootstrap-icons.css';

const Salas = () => {  
  const [salas, setSalas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTimeout, setSearchTimeout] = useState(null);
  const isFirstRequest = useRef(true);

  const { showNotification } = useNotification();

  const {
    page,
    pageSize,
    setTotalElements,
    setTotalPages,
    setPage,
  } = usePagination();

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    if (value.length >= 3 || value.length === 0) {
      const timeoutId = setTimeout(() => {
        isFirstRequest.current = true; // Reset para primeira requisição na busca
        fetchSalas(value);
      }, 500);
      setSearchTimeout(timeoutId);
    }
  };

  const fetchSalas = async (name = searchTerm) => {
    try {
      setLoading(true);
      const currentPage = isFirstRequest.current ? 0 : page;
      const queryParams = new URLSearchParams();
      if (name && name.length >= 3) {
        queryParams.append('name', name);
      }
      
      const url = `room/${currentPage}/${pageSize}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
      const response = await authFetch(url);

      if (!response.ok) throw new Error("Erro ao buscar salas");

      const data = await response.json();
      setSalas(data.content);
      setTotalElements(data.totalElements || 0);
      setTotalPages(data.totalPages || 0);
      
      // Atualiza a página após o request
      setPage(currentPage);
      isFirstRequest.current = false;
    } catch (err) {
      setError(err.message);
      showNotification("danger", "Erro ao carregar salas");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSalas();
  }, [page, pageSize]);

  if (error) return <p>Erro: {error}</p>;

  return (
    <div className="content">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="font-weight-bolder mb-0">Salas</h3>
        <div className="d-flex flex-wrap gap-2 align-items-center">
          <Link to={'Nova'} className='btn btn-info btn-sm'>Cadastrar Sala</Link>
        </div>
      </div>
      <div className="card">
        <div className="card-body p-3">
          <div className="d-flex justify-content-end mb-3">
            <div className="input-group" style={{ maxWidth: '300px' }}>
              <span className="input-group-text border-0 bg-transparent">
                <i className="bi bi-search text-secondary"></i>
              </span>
              <input
                type="text"
                className="form-control border-start-0 ps-0"
                placeholder="Buscar por nome..."
                value={searchTerm}
                onChange={handleSearch}
              />
            </div>
          </div>

          <SalasTable 
            salas={salas}
            loading={loading}
          />

          <PaginationControls currentCount={salas.length} />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Salas; 